/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kindle_Page_ErrorInputs */

const en_kindle_page_error = /** @type {(inputs: Kindle_Page_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindle could not load. Tap to reload the reader.`)
};

const es_kindle_page_error = /** @type {(inputs: Kindle_Page_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kindle no pudo cargar. Toca para recargar el lector.`)
};

/**
* | output |
* | --- |
* | "Kindle could not load. Tap to reload the reader." |
*
* @param {Kindle_Page_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const kindle_page_error = /** @type {((inputs?: Kindle_Page_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kindle_Page_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_kindle_page_error(inputs)
	return en_kindle_page_error(inputs)
});